import React from "react";
import _ from "lodash";
import { LOGIN, SIGNUP } from "../../../constants/onBoarding";
import LoginModal from "./LoginModal";
import SignupModal from "./SignupModal";

const AgentOnboardingModalWrapper = (props) => {

  const {
    handleAgentOnboardingModal,
    agentOnboardingPopup,
    handleResetPwdModal,
    handleUserLogin,
    handleMemberProfileModal,
    handleUserTypeModal,
  } = props;

  const isShowPopup = _.get(agentOnboardingPopup, "params.showPopup", false);
  const userAction = _.get(agentOnboardingPopup, "params.userAction", "");

  const isLogin = userAction === LOGIN;
  const isSignup = userAction === SIGNUP;

  const handleClose = () => {
    handleAgentOnboardingModal?.({ showPopup: false, userAction: null });
  };

  return (
    <>
      <LoginModal
        show={isShowPopup && isLogin}
        onHide={handleClose}
        onLoginSuccess={handleUserLogin}
        handleResetPwdModal={handleResetPwdModal}
        handleAgentOnboardingModal={handleAgentOnboardingModal}
      />

      <SignupModal
        show={isShowPopup && isSignup}
        onHide={handleClose}
        onLoginSuccess={handleUserLogin}
        agentOnboardingPopup={agentOnboardingPopup}
        handleAgentOnboardingModal={handleAgentOnboardingModal}
        handleMemberProfileModal={handleMemberProfileModal}
        handleUserTypeModal={handleUserTypeModal}
      />
    </>
  );
};

export default AgentOnboardingModalWrapper;
